var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_163",
    "data-name": "Group 163",
    transform: "translate(-1942.9 -963.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-eye-slash",
    "data-name": "Icon awesome-eye-slash",
    d: "M15,23.437c-3.555,0-6.434-3.44-6.7-7.8l-4.917-4.75a20.5,20.5,0,0,0-1.721,3.257,2.323,2.323,0,0,0,0,1.71C4.205,22.055,9.238,26.25,15,26.25a11.849,11.849,0,0,0,3.651-.613l-2.432-2.353A5.457,5.457,0,0,1,15,23.437Zm14.71,3.4-5.182-5.006a19.328,19.328,0,0,0,3.809-5.981,2.323,2.323,0,0,0,0-1.71C25.795,7.945,20.762,3.75,15,3.75A12.243,12.243,0,0,0,8.094,5.959L2.131.2A.655.655,0,0,0,1.078.362L.158,1.843A1.1,1.1,0,0,0,.29,3.158L27.869,29.8a.655.655,0,0,0,1.053-.165l.921-1.481a1.1,1.1,0,0,0-.132-1.315ZM21.1,18.521l-1.842-1.78A6.813,6.813,0,0,0,19.5,15a6.138,6.138,0,0,0-1.754-4.493A3.751,3.751,0,0,0,13.814,9.6a3.28,3.28,0,0,1,.436,1.653,3.37,3.37,0,0,1-.072.586L10.727,8.5A5.931,5.931,0,0,1,15,6.562a6.147,6.147,0,0,1,4.774,2.47A9.607,9.607,0,0,1,21.75,15a9.971,9.971,0,0,1-.652,3.522Z",
    transform: "translate(1942.9 963.5)",
    opacity: 0.62
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseEye);
export default __webpack_public_path__ + "static/media/close_eye.0f480e3bf376426816da88780d38286e.svg";
export { ForwardRef as ReactComponent };